import React, { useState, useRef } from "react";
import {
  SettingOutlined,
  SafetyCertificateOutlined,
  SwapOutlined,
  LogoutOutlined,
  RightOutlined,
  DesktopOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import classNames from "classnames";
import styles from "./index.modules.less";
import { useSelector } from "react-redux";
import { userLogOut } from "../../service/user";
import { useNavigate } from "react-router-dom";
import Copy from "../../image/copy2.svg";
import { CopyToClipboard } from "react-copy-to-clipboard";
import clasnames from "classnames";
import { message } from "../../components/Message";
import { resolveHeaderEntries, getPermissionName } from "../../utils/permission";
import { useWorkspace } from "../../context/WorkspaceRegionProvider";
import { WORKSPACE_CN, WORKSPACE_INTL } from "../../utils/workspace";
import { isMobileDevice } from "../../utils/util";

const Header = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const { user, permission } = useSelector((state) => state);
  const { workspace, setWorkspace, showWorkspaceSwitcher } = useWorkspace();
  const timerRef = useRef(null);
  const [copiedAppid, setCopiedAppid] = useState(false);
  const navigate = useNavigate();
  const headerEntries = resolveHeaderEntries({
    identityType: permission?.identityType,
    identityCount: permission?.identityCount,
  });
  const logoutHandle = () => {
    userLogOut();
    window.QHPass.signOut(function() {
      // alert("退出成功");
      navigate("/login");
    });

    console.log("logout");
  };
  console.log("user is", user)
  const useTouchMenu = () => isMobileDevice() || window.innerWidth <= 768;

  const show = () => {
    if (useTouchMenu()) return;
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsShowLogout(true);
      console.log('show')
    }, 300);
  };

  const hide = () => {
    if (useTouchMenu()) return;
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsShowLogout(false);
      console.log('hide')
    }, 300);
  };

  const toggleUserMenu = () => {
    if (!useTouchMenu()) return;
    setIsShowLogout(prev => !prev);
  };

  const isIntlWorkspace = workspace === WORKSPACE_INTL;
  const brandTitle = isIntlWorkspace ? "360 AppHub联运平台" : "360 软管联运平台";
  const BrandIcon = isIntlWorkspace ? GlobalOutlined : DesktopOutlined;

  return (
    <div className={styles.headerContainer}>
      <div className={styles.header}>
        <div className={styles.titleArea}>
          <div className={styles.brandGroup}>
            <BrandIcon
              className={classNames(styles.brandIcon, {
                [styles.brandIconIntl]: isIntlWorkspace,
                [styles.brandIconCn]: !isIntlWorkspace,
              })}
            />
            <h1 className={styles.title}>{brandTitle}</h1>
          </div>
          {showWorkspaceSwitcher ? (
            <button
              type="button"
              className={styles.workspaceSwitchBtn}
              onClick={() => {
                const nextWorkspace = isIntlWorkspace ? WORKSPACE_CN : WORKSPACE_INTL;
                setWorkspace(nextWorkspace);
                navigate("/view/home", { replace: true });
              }}
            >
              {isIntlWorkspace ? "切换至国内版" : "切换至国际版"}
            </button>
          ) : null}
        </div>
        <div className={styles.infoWrapper}>
          <img className={styles.headerIcon} src={user?.image_url} alt="" />
          <div
            className={styles.info}
            onClick={toggleUserMenu}
            onMouseEnter={() => show()}
            onMouseLeave={() => hide()}
          >
            <span
              className={classNames(styles.infoName, {
                [styles.infoHight]: isShowLogout === true,
              })}
            >
              {user?.user_name}
            </span>
            {!user?.is_mfr ? (
              <span className={styles.unverified}>未认证</span>
            ) : null}
            <i className={styles.icon}></i>
            {isShowLogout && (
              <div
                className={styles.logoutbox}
                onMouseEnter={() => show()}
                onMouseLeave={() => hide()}
              >
                <div className={styles.userInfo}>
                  <div className={styles.profileSection}>
                    <img className={styles.avar} src={user?.image_url} alt="" />
                    <div className={styles.profileDetail}>
                      <div className={styles.name}>
                        <span>{user?.user_name ? user?.user_name : "-----"}</span>
                      </div>
                      <div className={styles.cp}>
                        <span className={styles.vendorText} title={permission?.vendorName || user?.mfr_name || ""}>{permission?.vendorName || user?.mfr_name || "--"}</span>
                        {user?.is_mfr ? <img className={styles.mfrIcon} src="https://p1.ssl.qhimg.com/t01fa220eace62c9a4a.png"></img> : <img className={styles.mfrIcon} src="https://p4.ssl.qhimg.com/t015402c63486224ba3.png"></img>}
                        <span className={styles.identityTag}>{permission?.identityType === "owner" ? "主账号" : permission?.identityType === "sub_account" ? "子账号" : "身份未确定"}</span>
                      </div>
                      <CopyToClipboard
                        onCopy={() => {
                          message.show({
                            type: "success",
                            content: "复制成功！",
                          });
                          setCopiedAppid(true);
                        }}
                        text={user?.qid}
                      >
                        <div className={styles.qid}>
                          QID:{user?.qid}{" "}
                          <Copy
                            className={clasnames(styles.copy, {
                              [styles.copiedAppid]: !!copiedAppid,
                            })}
                          ></Copy>
                        </div>
                      </CopyToClipboard>
                    </div>
                  </div>
                  <div className={styles.actionList}>
                    {headerEntries.showPermissionManage && (
                      <div className={styles.actionItem} onClick={() => navigate("/view/permission_manage")}>
                        <span className={styles.actionLabel}><SettingOutlined className={styles.actionIcon} />权限管理</span>
                        <RightOutlined className={styles.actionArrow} />
                      </div>
                    )}
                    {headerEntries.showMyPermissions && (
                      <div className={styles.actionItem} onClick={() => navigate("/view/my_permissions")}>
                        <span className={styles.actionLabel}><SafetyCertificateOutlined className={styles.actionIcon} />我的权限</span>
                        <RightOutlined className={styles.actionArrow} />
                      </div>
                    )}
                    {headerEntries.showSwitchIdentity && (
                      <div
                        className={styles.actionItem}
                        onClick={() => navigate("/view/identity_select", { state: { source: "switch" } })}
                      >
                        <span className={styles.actionLabel}><SwapOutlined className={styles.actionIcon} />切换身份</span>
                        <RightOutlined className={styles.actionArrow} />
                      </div>
                    )}
                  </div>
                  <div className={styles.logoutSection} onClick={logoutHandle}>
                    <LogoutOutlined className={styles.actionIcon} />退出登录
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Header;
